<template>
	<div class="huanbao">
        <main>
            <div class="list">
                <h2>猪场环保风险点巡查表</h2>

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="zhuchang"
                    label="猪场"
                    placeholder="点击选择猪场"
                    @click="showPicker1 = true"
                />

                <van-field
                    readonly
                    clickable
                    name="picker"
                    :value="time"
                    label="巡查日期"
                    placeholder="点击选择日期"
                    @click="showPicker2 = true"
                />
                

                <van-button type="danger" style="width:100%;margin-top:20px" @click="daySure()">当日提交记录</van-button>

                <van-popup v-model="submit" position="bottom" :style="{ height: '60%', }" >
                    <van-cell-group v-for="(item,i) in list_all" :key="i">
                        <van-cell title="猪场" :value="item.zhuchang" />
                        <van-cell title="巡查区域" :value="item.quyu" />
                        <van-cell title="巡查频率" :value="item.pinlv" />
                        <van-cell title="风险点" :value="item.yichang" />
                        <van-cell title="是否异常" :value="item.radio==1?'是':'否'" />
                        <van-cell title="巡查人" :value="item.name" />
                        <van-cell title="描述" :value="item.beizhu" />
                        <van-divider :style="{ color: '#EE0A24', borderColor: '#EE0A24' }"></van-divider>
                    </van-cell-group>
                </van-popup>

                <van-popup v-model:show="showPicker1" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns1"
                        @confirm="onConfirm1"
                        @cancel="showPicker1 = false"
                    />
                </van-popup>

                <van-popup v-model:show="showPicker2" position="bottom">
                    <van-datetime-picker
                        v-model="currentDate"
                        type="date"
                        @confirm="onConfirm2"
                        @cancel="showPicker2 = false"
                    />
                </van-popup>





                <div v-if="show1!=1">   
                    <van-divider :style="{ color: '#EE0A24', borderColor: '#EE0A24', fontWeight: '600',fontSize:'16px',paddingTop: '30px'  }">{{cjz}}</van-divider>
                        
                        <div class="sub" >
                            <p>巡查频率： {{cjz_pinlve1}}</p>
                            <p>{{cjz1}}</p>
                            <van-radio-group v-model="cjz_radio1" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="cjz_beizhu1" label="描述" placeholder="具体描述" />
                            <van-field v-model="cjz_name1" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="cjz_fileList1" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(cjz,cjz1,cjz_pinlve1,cjz_radio1,cjz_beizhu1,cjz_name1,cjz_fileList1)">提交</van-button>

                        </div>

                        <div class="sub">
                            <p>巡查频率： {{cjz_pinlve2}}</p>
                            <p>{{cjz2}}</p>
                            <van-radio-group v-model="cjz_radio2" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="cjz_beizhu2" label="描述" placeholder="具体描述" />
                            <van-field v-model="cjz_name2" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="cjz_fileList2" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(cjz,cjz2,cjz_pinlve2,cjz_radio2,cjz_beizhu2,cjz_name2,cjz_fileList2)">提交</van-button>
                        </div>
                </div>



                <div v-if="show1!=1">   
                    <van-divider  :style="{ color: '#EE0A24', borderColor: '#EE0A24', fontWeight: '600',fontSize:'16px',paddingTop: '30px' }">{{xxzx}}</van-divider>
                        <div class="sub" >
                            <p>巡查频率： {{xxzx_pinlve1}}</p>
                            <p>{{xxzx1}}</p>
                            <van-radio-group v-model="xxzx_radio1" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="xxzx_beizhu1" label="描述" placeholder="具体描述" />
                            <van-field v-model="xxzx_name1" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="xxzx_fileList1" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(xxzx,xxzx1,xxzx_pinlve1,xxzx_radio1,xxzx_beizhu1,xxzx_name1,xxzx_fileList1)">提交</van-button>

                        </div>

                        <div class="sub">
                            <p>巡查频率： {{xxzx_pinlve2}}</p>
                            <p>{{xxzx2}}</p>
                            <van-radio-group v-model="xxzx_radio2" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="xxzx_beizhu2" label="描述" placeholder="具体描述" />
                            <van-field v-model="xxzx_name2" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="xxzx_fileList2" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(xxzx,xxzx2,xxzx_pinlve2,xxzx_radio2,xxzx_beizhu2,xxzx_name2,xxzx_fileList2)">提交</van-button>
                    </div>
                </div>

                <van-divider :style="{ color: '#EE0A24', borderColor: '#EE0A24', fontWeight: '600',fontSize:'16px',paddingTop: '30px' }">{{ws}}</van-divider>
                    <div class="sub">
                        <p>巡查频率： {{ws_pinlve1}}</p>
                        <p>{{ws1}}</p>
                        <van-radio-group v-model="ws_radio1" direction="horizontal" style="padding-left:16px">
                            <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                            <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                        </van-radio-group>
                        <van-field v-model="ws_beizhu1" label="描述" placeholder="具体描述" />
                        <van-field v-model="ws_name1" label="巡查人" placeholder="填写巡查人" />
                        <h4>请上传照片</h4>
                        <van-uploader  v-model="ws_fileList1" multiple :max-count="1"  :before-read="beforeRead"/>
                        <van-button type="danger" style="width:100%" @click="subAdmin(ws,ws1,ws_pinlve1,ws_radio1,ws_beizhu1,ws_name1,ws_fileList1)">提交</van-button>

                    </div>

                    <div class="sub">
                        <p>巡查频率： {{ws_pinlve2}}</p>
                        <p>{{ws2}}</p>
                        <van-radio-group v-model="ws_radio2" direction="horizontal" style="padding-left:16px">
                            <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                            <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                        </van-radio-group>
                        <van-field v-model="ws_beizhu2" label="描述" placeholder="具体描述" />
                        <van-field v-model="ws_name2" label="巡查人" placeholder="填写巡查人" />
                        <h4>请上传照片</h4>
                        <van-uploader  v-model="ws_fileList2" multiple :max-count="1"  :before-read="beforeRead"/>
                        <van-button type="danger" style="width:100%" @click="subAdmin(ws,ws2,ws_pinlve3,ws_radio2,ws_beizhu2,ws_name2,ws_fileList2)">提交</van-button>

                    </div>

                    <div class="sub">
                        <p>巡查频率： {{ws_pinlve3}}</p>
                        <p>{{ws3}}</p>
                        <van-radio-group v-model="ws_radio3" direction="horizontal" style="padding-left:16px">
                            <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                            <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                        </van-radio-group>
                        <van-field v-model="ws_beizhu3" label="描述" placeholder="具体描述" />
                        <van-field v-model="ws_name3" label="巡查人" placeholder="填写巡查人" />
                        <h4>请上传照片</h4>
                        <van-uploader  v-model="ws_fileList3" multiple :max-count="1"  :before-read="beforeRead"/>
                        <van-button type="danger" style="width:100%" @click="subAdmin(ws,ws3,ws_pinlve3,ws_radio3,ws_beizhu3,ws_name3,ws_fileList3)">提交</van-button>

                    </div>

                    <div class="sub">
                        <p>巡查频率： {{ws_pinlve4}}</p>
                        <p>{{ws4}}</p>
                        <van-radio-group v-model="ws_radio4" direction="horizontal" style="padding-left:16px">
                            <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                            <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                        </van-radio-group>
                        <van-field v-model="ws_beizhu4" label="描述" placeholder="具体描述" />
                        <van-field v-model="ws_name4" label="巡查人" placeholder="填写巡查人" />
                        <h4>请上传照片</h4>
                        <van-uploader  v-model="ws_fileList4" multiple :max-count="1"  :before-read="beforeRead"/>
                        <van-button type="danger" style="width:100%" @click="subAdmin(ws,ws4,ws_pinlve4,ws_radio4,ws_beizhu4,ws_name4,ws_fileList4)">提交</van-button>

                    </div>

                

                <van-divider :style="{ color: '#EE0A24', borderColor: '#EE0A24', fontWeight: '600',fontSize:'16px',paddingTop: '30px' }">{{zc}}</van-divider>
                    <div class="sub">
                        <p>巡查频率： {{zc_pinlve1}}</p>
                        <p>{{zc1}}</p>
                        <van-radio-group v-model="zc_radio1" direction="horizontal" style="padding-left:16px">
                            <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                            <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                        </van-radio-group>
                        <van-field v-model="zc_beizhu1" label="描述" placeholder="具体描述" />
                        <van-field v-model="zc_name1" label="巡查人" placeholder="填写巡查人" />
                        <h4>请上传照片</h4>
                        <van-uploader  v-model="zc_fileList1" multiple :max-count="1"  :before-read="beforeRead"/>
                        <van-button type="danger" style="width:100%" @click="subAdmin(zc,zc1,zc_pinlve1,zc_radio1,zc_beizhu1,zc_name1,zc_fileList1)">提交</van-button>

                    </div>

                    <div class="sub">
                        <p>巡查频率： {{zc_pinlve2}}</p>
                        <p>{{zc2}}</p>
                        <van-radio-group v-model="zc_radio2" direction="horizontal" style="padding-left:16px">
                            <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                            <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                        </van-radio-group>
                        <van-field v-model="zc_beizhu2" label="描述" placeholder="具体描述" />
                        <van-field v-model="zc_name2" label="巡查人" placeholder="填写巡查人" />
                        <h4>请上传照片</h4>
                        <van-uploader  v-model="zc_fileList2" multiple :max-count="1"  :before-read="beforeRead"/>
                        <van-button type="danger" style="width:100%" @click="subAdmin(zc,zc2,zc_pinlve2,zc_radio2,zc_beizhu2,zc_name2,zc_fileList2)">提交</van-button>

                    </div>
               


                <van-divider :style="{ color: '#EE0A24', borderColor: '#EE0A24', fontWeight: '600',fontSize:'16px',paddingTop: '30px'   }">{{cj}}</van-divider>
                    <div class="sub">
                        <p>巡查频率： {{cj_pinlve1}}</p>
                        <p>{{cj1}}</p>
                        <van-radio-group v-model="cj_radio1" direction="horizontal" style="padding-left:16px">
                            <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                            <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                        </van-radio-group>
                        <van-field v-model="cj_beizhu1" label="描述" placeholder="具体描述" />
                        <van-field v-model="cj_name1" label="巡查人" placeholder="填写巡查人" />
                        <h4>请上传照片</h4>
                        <van-uploader  v-model="cj_fileList1" multiple :max-count="1"  :before-read="beforeRead"/>
                        <van-button type="danger" style="width:100%" @click="subAdmin(cj,cj1,cj_pinlve1,cj_radio1,cj_beizhu1,cj_name1,cj_fileList1)">提交</van-button>

                    </div>

                    <div class="sub">
                        <p>巡查频率： {{cj_pinlve2}}</p>
                        <p>{{cj2}}</p>
                        <van-radio-group v-model="cj_radio2" direction="horizontal" style="padding-left:16px">
                            <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                            <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                        </van-radio-group>
                        <van-field v-model="cj_beizhu2" label="描述" placeholder="具体描述" />
                        <van-field v-model="cj_name2" label="巡查人" placeholder="填写巡查人" />
                        <h4>请上传照片</h4>
                        <van-uploader  v-model="cj_fileList2" multiple :max-count="1"  :before-read="beforeRead"/>
                        <van-button type="danger" style="width:100%" @click="subAdmin(cj,cj2,cj_pinlve2,cj_radio2,cj_beizhu2,cj_name2,cj_fileList2)">提交</van-button>

                    </div>

                    <div class="sub">
                        <p>巡查频率： {{cj_pinlve3}}</p>
                        <p>{{cj3}}</p>
                        <van-radio-group v-model="cj_radio3" direction="horizontal" style="padding-left:16px">
                            <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                            <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                        </van-radio-group>
                        <van-field v-model="cj_beizhu3" label="描述" placeholder="具体描述" />
                        <van-field v-model="cj_name3" label="巡查人" placeholder="填写巡查人" />
                        <h4>请上传照片</h4>
                        <van-uploader  v-model="cj_fileList3" multiple :max-count="1"  :before-read="beforeRead"/>
                        <van-button type="danger" style="width:100%" @click="subAdmin(cj,cj3,cj_pinlve3,cj_radio3,cj_beizhu3,cj_name3,cj_fileList3)">提交</van-button>

                    </div>

                    <div class="sub">
                        <p>巡查频率： {{cj_pinlve4}}</p>
                        <p>{{cj4}}</p>
                        <van-radio-group v-model="cj_radio4" direction="horizontal" style="padding-left:16px">
                            <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                            <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                        </van-radio-group>
                        <van-field v-model="cj_beizhu4" label="描述" placeholder="具体描述" />
                        <van-field v-model="cj_name4" label="巡查人" placeholder="填写巡查人" />
                        <h4>请上传照片</h4>
                        <van-uploader  v-model="cj_fileList4" multiple :max-count="1"  :before-read="beforeRead"/>
                        <van-button type="danger" style="width:100%" @click="subAdmin(cj,cj4,cj_pinlve4,cj_radio4,cj_beizhu4,cj_name4,cj_fileList4)">提交</van-button>

                    </div>



                <van-divider :style="{ color: '#EE0A24', borderColor: '#EE0A24', fontWeight: '600',fontSize:'16px', paddingTop: '30px'  }">{{zb}}</van-divider>

                    <div v-if="show1==5||show1==1">
                        <div class="sub">
                            <p>巡查频率： {{zb_pinlve1}}</p>
                            <p>{{zb1}}</p>
                            <van-radio-group v-model="zb_radio1" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="zb_beizhu1" label="描述" placeholder="具体描述" />
                            <van-field v-model="zb_name1" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="zb_fileList1" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,zb1,zb_pinlve1,zb_radio1,zb_beizhu1,zb_name1,zb_fileList1)">提交</van-button>

                        </div>

                        <div class="sub">
                            <p>巡查频率： {{zb_pinlve2}}</p>
                            <p>{{zb2}}</p>
                            <van-radio-group v-model="zb_radio2" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="zb_beizhu2" label="描述" placeholder="具体描述" />
                            <van-field v-model="zb_name2" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="zb_fileList2" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,zb2,zb_pinlve2,zb_radio2,zb_beizhu2,zb_name2,zb_fileList2)">提交</van-button>

                        </div>

                        <div class="sub">
                            <p>巡查频率： {{zb_pinlve3}}</p>
                            <p>{{zb3}}</p>
                            <van-radio-group v-model="zb_radio3" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="zb_beizhu3" label="描述" placeholder="具体描述" />
                            <van-field v-model="zb_name3" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="zb_fileList3" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,zb3,zb_pinlve3,zb_radio3,zb_beizhu3,zb_name3,zb_fileList3)">提交</van-button>

                        </div>

                        <div class="sub">
                            <p>巡查频率： {{zb_pinlve4}}</p>
                            <p>{{zb4}}</p>
                            <van-radio-group v-model="zb_radio4" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="zb_beizhu4" label="描述" placeholder="具体描述" />
                            <van-field v-model="zb_name4" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="zb_fileList4" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,zb4,zb_pinlve4,zb_radio4,zb_beizhu4,zb_name4,zb_fileList4)">提交</van-button>

                        </div>

                        <div class="sub">
                            <p>巡查频率： {{zb_pinlve5}}</p>
                            <p>{{zb5}}</p>
                            <van-radio-group v-model="zb_radio5" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="zb_beizhu5" label="描述" placeholder="具体描述" />
                            <van-field v-model="zb_name5" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="zb_fileList5" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,zb5,zb_pinlve5,zb_radio5,zb_beizhu5,zb_name5,zb_fileList5)">提交</van-button>

                        </div>
                    </div>

                    <!-- 三亩田 -->
                    <div v-if="show1==2">
                        <div class="sub">
                            <p>巡查频率： {{smt_pinlve1}}</p>
                            <p>{{smt1}}</p>
                            <van-radio-group v-model="smt_radio1" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="smt_beizhu1" label="描述" placeholder="具体描述" />
                            <van-field v-model="smt_name1" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="smt_fileList1" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,smt1,smt_pinlve1,smt_radio1,smt_beizhu1,smt_name1,smt_fileList1)">提交</van-button>
                        </div>

                        <div class="sub">
                            <p>巡查频率： {{smt_pinlve2}}</p>
                            <p>{{smt2}}</p>
                            <van-radio-group v-model="smt_radio2" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="smt_beizhu2" label="描述" placeholder="具体描述" />
                            <van-field v-model="smt_name2" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="smt_fileList2" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,smt2,smt_pinlve2,smt_radio2,smt_beizhu2,smt_name2,smt_fileList2)">提交</van-button>
                        </div>

                        <div class="sub">
                            <p>巡查频率： {{smt_pinlve3}}</p>
                            <p>{{smt3}}</p>
                            <van-radio-group v-model="smt_radio3" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="smt_beizhu3" label="描述" placeholder="具体描述" />
                            <van-field v-model="smt_name3" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="smt_fileList3" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,smt3,smt_pinlve3,smt_radio3,smt_beizhu3,smt_name3,smt_fileList3)">提交</van-button>
                        </div>

                        <div class="sub">
                            <p>巡查频率： {{smt_pinlve4}}</p>
                            <p>{{smt4}}</p>
                            <van-radio-group v-model="smt_radio4" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="smt_beizhu4" label="描述" placeholder="具体描述" />
                            <van-field v-model="smt_name4" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="smt_fileList4" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,smt4,smt_pinlve4,smt_radio4,smt_beizhu4,smt_name4,smt_fileList4)">提交</van-button>
                        </div>

                        <div class="sub">
                            <p>巡查频率： {{smt_pinlve5}}</p>
                            <p>{{smt5}}</p>
                            <van-radio-group v-model="smt_radio5" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="smt_beizhu5" label="描述" placeholder="具体描述" />
                            <van-field v-model="smt_name5" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="smt_fileList5" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,smt5,smt_pinlve5,smt_radio5,smt_beizhu5,smt_name5,smt_fileList5)">提交</van-button>
                        </div>

                        <div class="sub">
                            <p>巡查频率： {{smt_pinlve6}}</p>
                            <p>{{smt6}}</p>
                            <van-radio-group v-model="smt_radio6" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="smt_beizhu6" label="描述" placeholder="具体描述" />
                            <van-field v-model="smt_name6" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="smt_fileList6" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,smt6,smt_pinlve6,smt_radio6,smt_beizhu6,smt_name6,smt_fileList6)">提交</van-button>
                        </div>

                        <div class="sub">
                            <p>巡查频率： {{smt_pinlve7}}</p>
                            <p>{{smt7}}</p>
                            <van-radio-group v-model="smt_radio7" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="smt_beizhu7" label="描述" placeholder="具体描述" />
                            <van-field v-model="smt_name7" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="smt_fileList7" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,smt7,smt_pinlve7,smt_radio7,smt_beizhu7,smt_name7,smt_fileList7)">提交</van-button>
                        </div>
                    </div>

                    <!-- 瓦窑头 -->
                    <div  v-if="show1==3">
                        <div class="sub">
                            <p>巡查频率： {{wyt_pinlve1}}</p>
                            <p>{{wyt1}}</p>
                            <van-radio-group v-model="wyt_radio1" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="wyt_beizhu1" label="描述" placeholder="具体描述" />
                            <van-field v-model="wyt_name1" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="wyt_fileList1" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,wyt1,wyt_pinlve1,wyt_radio1,wyt_beizhu1,wyt_name1,wyt_fileList1)">提交</van-button>
                        </div>

                        <div class="sub">
                            <p>巡查频率： {{wyt_pinlve2}}</p>
                            <p>{{wyt2}}</p>
                            <van-radio-group v-model="wyt_radio2" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="wyt_beizhu2" label="描述" placeholder="具体描述" />
                            <van-field v-model="wyt_name2" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="wyt_fileList2" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,wyt2,wyt_pinlve2,wyt_radio2,wyt_beizhu2,wyt_name2,wyt_fileList2)">提交</van-button>
                        </div>

                        <div class="sub">
                            <p>巡查频率： {{wyt_pinlve3}}</p>
                            <p>{{wyt3}}</p>
                            <van-radio-group v-model="wyt_radio3" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="wyt_beizhu3" label="描述" placeholder="具体描述" />
                            <van-field v-model="wyt_name3" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="wyt_fileList3" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,wyt3,wyt_pinlve3,wyt_radio3,wyt_beizhu3,wyt_name3,wyt_fileList3)">提交</van-button>
                        </div>

                        <div class="sub">
                            <p>巡查频率： {{wyt_pinlve4}}</p>
                            <p>{{wyt4}}</p>
                            <van-radio-group v-model="wyt_radio4" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="wyt_beizhu4" label="描述" placeholder="具体描述" />
                            <van-field v-model="wyt_name4" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="wyt_fileList4" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,wyt4,wyt_pinlve4,wyt_radio4,wyt_beizhu4,wyt_name4,wyt_fileList4)">提交</van-button>
                        </div>
                    </div>


                    <!-- 下各 -->
                    <div  v-if="show1==4">
                        <div class="sub">
                            <p>巡查频率： {{xg_pinlve1}}</p>
                            <p>{{xg1}}</p>
                            <van-radio-group v-model="xg_radio1" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="xg_beizhu1" label="描述" placeholder="具体描述" />
                            <van-field v-model="xg_name1" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="xg_fileList1" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,xg1,xg_pinlve1,xg_radio1,xg_beizhu1,xg_name1,xg_fileList1)">提交</van-button>
                        </div>

                        <div class="sub">
                            <p>巡查频率： {{xg_pinlve2}}</p>
                            <p>{{xg2}}</p>
                            <van-radio-group v-model="xg_radio2" direction="horizontal" style="padding-left:16px">
                                <van-radio name="1" icon-size="16px" checked-color="#ee0a24">是</van-radio>
                                <van-radio name="2" icon-size="16px" checked-color="#ee0a24">否</van-radio>
                            </van-radio-group>
                            <van-field v-model="xg_beizhu2" label="描述" placeholder="具体描述" />
                            <van-field v-model="xg_name2" label="巡查人" placeholder="填写巡查人" />
                            <h4>请上传照片</h4>
                            <van-uploader  v-model="xg_fileList2" multiple :max-count="1"  :before-read="beforeRead"/>
                            <van-button type="danger" style="width:100%" @click="subAdmin(zb,xg2,xg_pinlve2,xg_radio2,xg_beizhu2,xg_name2,xg_fileList2)">提交</van-button>
                        </div>
                    </div>

            </div>
        </main>
    </div>
</template>

<script>
    import { url2 } from '../router/api';
    import option from "../config/option.js"
	export default{
		data(){
			return{
                loading:'',
                columns1:[],

                zhuchang:'',
                time:'',
                currentDate: new Date(),
                showPicker1:false,
                showPicker2:false,
                
                cjz:'初级站',
                cjz_pinlve1:'每周巡查一次',
                cjz_pinlve2:'每周巡查一次',
                cjz1:'初级站内排水沟和排水口是否有污水流出',
                cjz2:'初级站场界巡查，是否有污水流出或垃圾存在',
                cjz_name1:'',
                cjz_name2:'',
                cjz_beizhu1:'',
                cjz_beizhu2:'',
                cjz_radio1: '',
                cjz_radio2: '',
                cjz_fileList1: [],
                cjz_fileList2: [],

                xxzx:'洗消中心',
                xxzx_pinlve1:'每天巡查一次',
                xxzx_pinlve2:'每天巡查一次',
                xxzx1:'洗消中心内排污点是否有污水流出',
                xxzx2:'洗消中心场界巡查，是否有污水流出或垃圾存在',
                xxzx_name1:'',
                xxzx_name2:'',
                xxzx_beizhu1:'',
                xxzx_beizhu2:'',
                xxzx_radio1: '',
                xxzx_radio2: '',
                xxzx_fileList1: [],
                xxzx_fileList2: [],

                ws:'污水站',
                ws_pinlve1:'每天巡查一次',
                ws_pinlve2:'每天巡查一次',
                ws_pinlve3:'每天巡查一次',
                ws_pinlve4:'每天巡查一次',
                ws1:'原水收集池液位异常，是否满溢或渗漏',
                ws2:'污水管网污排查，是否有渗漏',
                ws3:'外排水池出水水质检查，是否异常',
                ws4:'应急池液位是否异常，是否满溢或渗漏',
                ws_name1:'',
                ws_name2:'',
                ws_name3:'',
                ws_name4:'',
                ws_beizhu1:'',
                ws_beizhu2:'',
                ws_beizhu3:'',
                ws_beizhu4:'',
                ws_radio1: '',
                ws_radio2: '',
                ws_radio3: '',
                ws_radio4: '',
                ws_fileList1: [],
                ws_fileList2: [],
                ws_fileList3: [],
                ws_fileList4: [],

                zc:'猪场内',
                zc_pinlve1:'每天巡查一次',
                zc_pinlve2:'每周巡查两次',
                zc1:'场内雨污管网是否异常',
                zc2:'全场周边巡查是否异常',
                zc_name1:'',
                zc_name2:'',
                zc_beizhu1:'',
                zc_beizhu2:'',
                zc_radio1: '',
                zc_radio2: '',
                zc_fileList1: [],
                zc_fileList2: [],

                cj:'猪场场界',
                cj_pinlve1:'每周巡查两次',
                cj_pinlve2:'每周巡查两次',
                cj_pinlve3:'每周巡查两次',
                cj_pinlve4:'每周巡查两次',
                cj1:'场界外围是否有污水渗漏',
                cj2:'场界围墙外围是否破损或出现病死动物情况',
                cj3:'场界是否存在山体滑坡',
                cj4:'场界外围排水口是否有污水流出',
                cj_name1:'',
                cj_name2:'',
                cj_name3:'',
                cj_name4:'',
                cj_beizhu1:'',
                cj_beizhu2:'',
                cj_beizhu3:'',
                cj_beizhu4:'',
                cj_radio1: '',
                cj_radio2: '',
                cj_radio3: '',
                cj_radio4: '',
                cj_fileList1: [],
                cj_fileList2: [],
                cj_fileList3: [],
                cj_fileList4: [],

                zb:'猪场周边河道、水库、消纳地、纳管泵站、污水装车点',
                zb_pinlve1:'每周巡查两次',
                zb_pinlve2:'每周巡查两次',
                zb_pinlve3:'每周巡查两次',
                zb_pinlve4:'每周巡查两次',
                zb_pinlve5:'每周巡查两次',
                zb1:'猪场周边河道是否有猪场污水流入',
                zb2:'猪场周边水库是否有猪场污水流入',
                zb3:'污水纳管泵站设施设备是否运行异常，是否渗漏',
                zb4:'消纳地下游水是否有污水流入或水质异常',
                zb5:'污水装车点是否存在污水泄露情况',
                zb_name1:'',
                zb_name2:'',
                zb_name3:'',
                zb_name4:'',
                zb_name5:'',
                zb_beizhu1:'',
                zb_beizhu2:'',
                zb_beizhu3:'',
                zb_beizhu4:'',
                zb_beizhu5:'',
                zb_radio1: '',
                zb_radio2: '',
                zb_radio3: '',
                zb_radio4: '',
                zb_radio5: '',
                zb_fileList1: [],
                zb_fileList2: [],
                zb_fileList3: [],
                zb_fileList4: [],
                zb_fileList5: [],

                smt_pinlve1:'每周巡查两次',
                smt_pinlve2:'每周巡查两次',
                smt_pinlve3:'每周巡查两次',
                smt_pinlve4:'每周巡查两次',
                smt_pinlve5:'每周巡查两次',
                smt_pinlve6:'每周巡查两次',
                smt_pinlve7:'每周巡查两次',
                smt1:'三亩田村口河道',
                smt2:'三亩田水库',
                smt3:'三亩田半山腰污水阀',
                smt4:'三亩田后山河道',
                smt5:'牛栏头村河道',
                smt6:'千寻广度村方向河流',
                smt7:'市政纳管管道或泵站',
                smt_name1:'',
                smt_name2:'',
                smt_name3:'',
                smt_name4:'',
                smt_name5:'',
                smt_name6:'',
                smt_name7:'',
                smt_beizhu1:'',
                smt_beizhu2:'',
                smt_beizhu3:'',
                smt_beizhu4:'',
                smt_beizhu5:'',
                smt_beizhu6:'',
                smt_beizhu7:'',
                smt_radio1: '',
                smt_radio2: '',
                smt_radio3: '',
                smt_radio4: '',
                smt_radio5: '',
                smt_radio6: '',
                smt_radio7: '',
                smt_fileList1: [],
                smt_fileList2: [],
                smt_fileList3: [],
                smt_fileList4: [],
                smt_fileList5: [],
                smt_fileList6: [],
                smt_fileList7: [],

                wyt_pinlve1:'每周巡查两次',
                wyt_pinlve2:'每周巡查两次',
                wyt_pinlve3:'每周巡查两次',
                wyt_pinlve4:'每周巡查两次',
                wyt1:'猪场后门斜坡',
                wyt2:'宋家山河流',
                wyt3:'宋口村河流',
                wyt4:'市政纳管管道或泵站（在线监测纳管所有管路及池子）',
                wyt_name1:'',
                wyt_name2:'',
                wyt_name3:'',
                wyt_name4:'',
                wyt_beizhu1:'',
                wyt_beizhu2:'',
                wyt_beizhu3:'',
                wyt_beizhu4:'',
                wyt_radio1: '',
                wyt_radio2: '',
                wyt_radio3: '',
                wyt_radio4: '',
                wyt_fileList1: [],
                wyt_fileList2: [],
                wyt_fileList3: [],
                wyt_fileList4: [],


                xg_pinlve1:'每周巡查两次',
                xg_pinlve2:'每周巡查两次',
                xg1:'猪场周边河道、水库是否有猪场污水流入',
                xg2:'市政纳管管道或泵站（在线监测纳管所有管路及池子）',
                xg_name1:'',
                xg_name2:'',
                xg_beizhu1:'',
                xg_beizhu2:'',
                xg_radio1: '',
                xg_radio2: '',
                xg_fileList1: [],
                xg_fileList2: [],


                show1:1,
                send_time:'',
                submit:false,
                list_all:'',
            }
        },

        mounted() {
            const elementToRemove = '全部';
            this.columns1 = option.huanbao.filter(item => item !== elementToRemove);

            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            this.send_time = Y + M +D
        },

		methods: {
            subAdmin(quyu,yichang,pinlv,radio,beizhu,name,file) {
                if(this.zhuchang=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请选择猪场',
                    }).then(() => {
                        return;
                    });
                } else if(this.time=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请选择巡查日期',
                    }).then(() => {
                        return;
                    });
                } else if(radio=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请选择风险点是否异常',
                    }).then(() => {
                        return;
                    });
                } else if(name=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请填写巡查人',
                    }).then(() => {
                        return;
                    });
                } else if(file=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请上传照片',
                    }).then(() => {
                        return;
                    });
                } else {
                    this.$dialog.confirm({
                        title: '提示',
                        message: '是否确定提交',
                    }).then(() => {
                        this.loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: '加载中',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        var formData =new FormData();
                        formData.append('file[]',file[0].file);
                        this.axios.post(url2+'upload3',(formData),{
                            headers: {  'Content-Type': 'multipart/form-data;' }
                        }).then(res=> {
                            if(res.data.code==1) {
                                this.sure2(res.data.data,quyu,yichang,pinlv,radio,beizhu,name)
                            }  else {
                                this.loading.close();
                            }
                        }).catch(err=> {
                            this.loading.close();
                            console.log(err);
                        });
                    }).catch(() => {});
                }
            },

            sure2(photo,quyu,yichang,pinlv,radio,beizhu,name) {
                this.axios.get(url2+'huanbao', {
                    params:{
                        zhuchang:this.zhuchang,
                        time:this.time,
                        url:photo.toString(),
                        quyu:quyu,
                        yichang:yichang,
                        pinlv:pinlv,
                        radio:radio,
                        beizhu:beizhu,
                        name:name,
                    }
                }).then(res=> {
                    if(res.status==200) {
                        this.loading.close();
                        this.$dialog.alert({
                            title: '提示',
                            message: '提交成功',
                        }).then(() => {
                            // console.log(res)
                            // this.$router.go(0)
                        });
                    } else {
                        this.loading.close();
                    }
                }).catch(err=> {
                    this.loading.close();
                    console.log(err);
                });
            },

            onConfirm1(value) {
                // console.log(value)
                if(value=='里塘猪场') {
                    this.show1 = 1
                } else if(value=='仙居三亩田猪场') {
                    this.show1 = 2
                } else if(value=='仙居瓦垚头猪场') {
                    this.show1 = 3
                }else if(value=='仙居下各猪场') {
                    this.show1 = 4
                } else {
                    this.show1 = 5
                }

                this.zhuchang = value;
                this.showPicker1 = false;
            },

            daySure() {
                if(this.zhuchang=='') {
                    this.$dialog.alert({
                        title: '提示',
                        message: '请先选择猪场',
                    }).then(() => {});
                } else {
                    this.axios.get(url2+'huanbaoSearch', {
                        params:{
                            page:1,
                            per_page:9999,
                            time:this.send_time,
                            zhuchang:this.zhuchang,
                            zhuangtai:'',
                            xuncharen:'',
                            crate_time1:'',
                            crate_time2:'',
                        }
                        }).then(res=> {
                            if(res.data.data.data.length!=0) {
                                this.submit = true
                                this.list_all = res.data.data.data
                            } else {
                                this.$dialog.alert({
                                    title: '提示',
                                    message: '暂无提交记录',
                                }).then(() => {});
                            }
                    }).catch(err=> {
                        console.log(err);
                    });
                }
            },


            onConfirm2(value) {
                this.time = this.formatDate(value)
                this.showPicker2 = false;
            },

            formatDate(date) {
                let y = date.getFullYear()
                let m = date.getMonth() + 1
                let d = date.getDate()
                m = m < 10 ? '0' + m : m
                d = d < 10 ? '0' + d : d
                return `${y}-${m}-${d}`;
            },
            beforeRead(file){
               return this.$compress(file)
            },

        }

    }
</script>

<style scoped="scoped" lang='less'>
    .huanbao .sub {
        border: solid 1px #ccc;
        margin-bottom: 10px;
        padding: 10px;
        p {
            padding-left: 16px;
        }
        h4 {
            margin: 10px 0;
        }
    }
    .huanbao main {
        font-size: 14px;
        padding: 40px 16px 28px 16px;
        background-color: #FFDCA3;
    }
    .huanbao .list {
        background-color: #fff;
        padding: 20px;
    }
    .huanbao h2 {
        color: #EE0A24;
        text-align: center;
        margin-bottom: 20px;
    }
   
    .huanbao /deep/ .van-field__label {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        flex: none;
        box-sizing: border-box;
        width: 6.2em;
        margin-right: 30px;
        color: #646566;
        text-align: left;
        word-wrap: break-word;
    }
    .huanbao h4 {
        text-indent: 16px;
    }
    .huanbao /deep/ .van-uploader {
        position: relative;
        display: inline-block;
        margin-left: 16px;
    }
</style>




